// The basics every workspace starts with. Each one shows as a recommendation
// until it is done, the code and Linear first because the agent answers from them.
export const AGENT_SETUP_STEPS = [
	{
		id: "github",
		title: "Connect GitHub",
		action: "Connect GitHub",
		path: "/settings/integrations/github",
		body: "Link your repository and I learn your product from the code. That lets me answer the deep questions too, the ones that need a look at how something works.",
	},
	{
		id: "linear",
		title: "Connect Linear",
		action: "Connect Linear",
		path: "/settings/integrations/linear",
		body: "With Linear connected, a question I can't answer becomes an issue that carries the customer and what I found. When the issue ships, the customer hears back.",
	},
	{
		id: "email",
		title: "Add your support email",
		action: "Add email",
		path: "/settings/emails",
		body: "Forward your support address to Productlane and customer emails arrive in your inbox, where I answer them.",
	},
	{
		id: "widget",
		title: "Install the widget",
		action: "Install widget",
		path: "/settings/widget",
		body: "Add the widget to your app and customers can ask me from any page, with your help center one click away.",
	},
	{
		id: "domain",
		title: "Connect your domain",
		action: "Connect domain",
		path: "/settings/portal/domain",
		body: "Serve your help center from your own domain, like help.yourcompany.com, so customers find it under your name.",
	},
] as const

export type AgentSetupId = (typeof AGENT_SETUP_STEPS)[number]["id"]
export type AgentSetupStep = (typeof AGENT_SETUP_STEPS)[number]
export type AgentSetupProgress = Record<AgentSetupId, boolean>

export function setupItemId(id: AgentSetupId): string {
	return `setup-${id}`
}

/** The steps still open, in order; a done or declined step leaves the list. */
/** Until its query answers, the widget counts as installed, so its row never flashes in and out. */
export function widgetStepDone(
	hasWidgetThread: boolean,
	known: boolean,
): boolean {
	return hasWidgetThread || !known
}

export function openSetupSteps(
	progress: AgentSetupProgress,
	declined: readonly AgentSetupId[] = [],
): AgentSetupStep[] {
	return AGENT_SETUP_STEPS.filter(
		(step) => !progress[step.id] && !declined.includes(step.id),
	)
}
